// extracted by mini-css-extract-plugin
module.exports = {"container":"orderHeader_container__1744E","content":"orderHeader_content__ycnWR","orderDate":"orderHeader_orderDate__xvjCM","contentActions":"orderHeader_contentActions__1Ssbr"};